import service from "@/utils/request";

// 活动列表
export const getActivityPresetFormListApi = () => {
  return service({
    url: "/api/v1/market_activity/preset_form/list",
    method: "get",
  });
};
export interface getActivityListData {
  page: number;
  page_size: number;
  title?: string;
  type_id?: number;
  status?: number;
  activity_status?: number;
  roster_start_num?: number;
  roster_end_num?: number;
  time_type?: number;
  start_time?: number;
  end_time?: number;
  effective_roster_start_num?: number;
  effective_roster_end_num?: number;
}
export const getActivityListApi = (params: getActivityListData) => {
  return service({
    url: "/api/v1/market_activity/list",
    method: "get",
    params,
  });
};

export interface getActivitySelectListData {
  page: number;
  page_size: number;
  title?: string;
  type_id?: number;
  status?: number;
  activity_status?: number;
  roster_start_num?: number;
  roster_end_num?: number;
  time_type?: number;
  start_time?: number;
  end_time?: number;
  activity_status_arr?: number[];
}
export const getActivitySelectListApi = (data: getActivitySelectListData) => {
  return service({
    url: "/api/v1/market_activity/select_list",
    method: "post",
    data,
  });
};

export interface getActivityDetailData {
  activity_id: number;
}
export const getActivityDetailApi = (params: getActivityDetailData) => {
  return service({
    url: "/api/v1/market_activity/detail",
    method: "get",
    params,
  });
};

export interface addActivityData {
  type_id: number;
  title: string;
  start_time: number;
  end_time: number;
  stock: number;
  appear_id: number;
  source_id: number;
  status: number;
  sort: number;
  is_promotion: number;
  cover_list?: [annex_content: string, annex_type: number, sort: number];
  form_list: [
    preset_form_id: number,
    type: number,
    title: string,
    default_value: string,
    is_require: number,
    sort: number
  ];
  market_staff_ids: number;
  promotion: {
    title: string;
    quotation: string;
    image_list: [annex_content: string, annex_type: number, sort: number];
    desc_list: [annex_content: string, annex_type: number, sort: number];
  } | null;
}
export const addActivityApi = (data: addActivityData) => {
  return service({
    url: "/api/v1/market_activity/add",
    method: "post",
    data,
  });
};

export interface editActivityData extends addActivityData {
  activity_id: number;
}
export const editActivityApi = (data: editActivityData) => {
  return service({
    url: "/api/v1/market_activity/edit",
    method: "post",
    data,
  });
};

export interface delActivityData {
  activity_id: number;
}
export const delActivityApi = (data: delActivityData) => {
  return service({
    url: "/api/v1/market_activity/del",
    method: "post",
    data,
  });
};

export interface editActivityStatusData {
  activity_id: number;
  status: number;
}
export const editActivityStatusApi = (data: editActivityStatusData) => {
  return service({
    url: "/api/v1/market_activity/edit_status",
    method: "post",
    data,
  });
};

// 推广引流(市场顾问列表)
export interface getMarketStaffListData {
  page: number;
  page_size: number;
  market_staff_id?: number;
  status?: number;
  full_time?: number;
  create_start_time?: number;
  create_end_time?: number;
  keyword?: string;
}
export const getMarketStaffListApi = (params: getMarketStaffListData) => {
  return service({
    url: "/api/v1/market_staff/list",
    method: "get",
    params,
  });
};

// 市场顾问导出
export interface exportMarketStaffListData {
  page: number;
  page_size: number;
  market_staff_id?: number;
  status?: number;
  full_time?: number;
  create_start_time?: number;
  create_end_time?: number;
}
export const exportMarketStaffListApi = (params: exportMarketStaffListData) => {
  return service({
    url: "/api/v1/market_staff/list_export",
    method: "get",
    params,
  });
};

export interface getPromotionQrcodeListData {
  page: number;
  page_size: number;
  activity_id: number;
  market_staff_id?: number;
}
export const getPromotionQrcodeListApi = (
  params: getPromotionQrcodeListData
) => {
  return service({
    url: "/api/v1/market_activity/promotion/qrcode_list",
    method: "get",
    params,
  });
};

// 活动类型
export interface getActivityTypeListData {
  page: number;
  page_size: number;
  title?: string;
}
export const getActivityTypeListApi = (params: getActivityTypeListData) => {
  return service({
    url: "/api/v1/market_activity/type/list",
    method: "get",
    params,
  });
};

export interface getActivitySelectTypeListData {
  page: number;
  page_size: number;
  title?: string;
}
export const getActivitySelectTypeListApi = (
  params: getActivitySelectTypeListData
) => {
  return service({
    url: "/api/v1/market_activity/type/select_list",
    method: "get",
    params,
  });
};

export interface addActivityTypeData {
  title: string;
  sort?: number;
}
export const addActivityTypeApi = (data: addActivityTypeData) => {
  return service({
    url: "/api/v1/market_activity/type/add",
    method: "post",
    data,
  });
};

export interface editActivityTypeData {
  type_id: number;
  title: string;
  sort?: number;
}
export const editActivityTypeApi = (data: editActivityTypeData) => {
  return service({
    url: "/api/v1/market_activity/type/edit",
    method: "post",
    data,
  });
};

export interface delActivityTypeData {
  type_id: number;
}
export const delActivityTypeApi = (data: delActivityTypeData) => {
  return service({
    url: "/api/v1/market_activity/type/del",
    method: "post",
    data,
  });
};

// 查看意向名单
export interface getActivityRosterListData {
  page: number;
  page_size: number;
  keyword?: string;
  activity_id?: number;
  market_staff_id?: number;
  type_id?: number;
  commit_status?: number;
  create_start_time?: number;
  create_end_time?: number;
  is_official?: number;
}
export const getActivityRosterListApi = (params: getActivityRosterListData) => {
  return service({
    url: "/api/v1/market_activity/roster/list",
    method: "get",
    params,
  });
};

// 导出意向名单
export interface exportActivityRosterListData {
  page: number;
  page_size: number;
  keyword?: string;
  activity_id?: number;
  market_staff_id?: number;
  type_id?: number;
  commit_status?: number;
  create_start_time?: number;
  create_end_time?: number;
}
export const exportActivityRosterListApi = (
  params?: exportActivityRosterListData
) => {
  return service({
    url: "/api/v1/market_activity/roster/list_export",
    method: "get",
    params,
  });
};

// 销售金额明细
export interface getSalesAmountDetailListData {
  page: number;
  page_size: number;
  keyword?: string;
  activity_id?: number;
  market_staff_id?: number;
  type_id?: number;
  commit_status?: number;
  create_start_time?: number;
  create_end_time?: number;
  order_no?: string;
  is_pay?: number;
  activity_ids?: string[];
  is_official?: number;
}
export const getSalesAmountDetailListApi = (
  data: getSalesAmountDetailListData
) => {
  return service({
    url: "/api/v1/market_activity/roster/sales_amount",
    method: "post",
    data,
  });
};

// 销售金额明细导出
export interface exportSalesAmountListData {
  page: number;
  page_size: number;
  keyword?: string;
  activity_id?: number;
  market_staff_id?: number;
  type_id?: number;
  commit_status?: number;
  create_start_time?: number;
  create_end_time?: number;
  order_no?: string;
  is_pay?: number;
  activity_ids?: string[];
}
export const exportSalesAmountListApi = (params: exportSalesAmountListData) => {
  return service({
    url: "/api/v1/market_activity/roster/sales_amount_export",
    method: "get",
    params,
  });
};

export interface getActivityRosterHeaderListData {
  activity_id: number;
}
export const getActivityRosterHeaderListApi = (
  params: getActivityRosterHeaderListData
) => {
  return service({
    url: "/api/v1/market_activity/roster/header_list",
    method: "get",
    params,
  });
};
